import { render } from "./CadastroLicencaOrgao.vue?vue&type=template&id=9bce12ba"
import script from "./CadastroLicencaOrgao.vue?vue&type=script&lang=ts"
export * from "./CadastroLicencaOrgao.vue?vue&type=script&lang=ts"
script.render = render

export default script